import { useState } from "react";

export const useEntryLink = (): {
  handleClickEntryLink: () => void;
} => {
  const [isClicked, setIsClicked] = useState(false);

  const handleClickEntryLink = () => {
    if (!isClicked) {
      setIsClicked(true);
    }
  };

  return { handleClickEntryLink };
};
